import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=c17a1320&scoped=true"
import script from "./DeliveryForm.vue?vue&type=script&lang=ts"
export * from "./DeliveryForm.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=c17a1320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17a1320",
  null
  
)

export default component.exports